module.exports = __webpack_public_path__ + "img/hint1.4fa7e6b5.png";